import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=5927a574&scoped=true&"
import script from "./AdminPanel.vue?vue&type=script&lang=ts&"
export * from "./AdminPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=5927a574&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927a574",
  null
  
)

export default component.exports